"use client";

import { Suspense, useEffect } from "react";
import { sendGAEvent } from "@next/third-parties/google";
import { useUser } from "@/contexts/user-context";
import { isAuthPersistent } from "@/utils/analytics";
import { useSearchParams } from "next/navigation";

const GoogleAnalyticsInner = () => {
  const searchParams = useSearchParams();
  const { isAuthenticated } = useUser();

  useEffect(() => {
    sendGAEvent("event", "view_item_list", {
      user_auth_state: (isAuthenticated || isAuthPersistent()) ? "logged_in" : "logged_out",
    });
  }, [searchParams.toString(), isAuthenticated]);

  return null;
};

const GoogleAnalyticsClient = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <Suspense fallback={null}>
        <GoogleAnalyticsInner />
      </Suspense>
      {children}
    </>
  );
};

export default GoogleAnalyticsClient;
